<template>
  <div class="container py-3">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <h2 class="mb-0">
        Performers — <small class="text-muted">{{ stageName }}</small>
      </h2>
      <span class="badge bg-light text-dark">{{ performers.length }} total</span>
    </div>
    <div v-if="!performers.length" class="text-muted my-4">
      No performers found for this stage.
    </div>

    <!-- Cards -->
    <div class="row">
      <div
        v-for="(p, idx) in performers"
        :key="p._id"
        class="col-md-4 col-sm-6 mb-4 d-flex"
      >
        <div class="card performer-card mx-auto text-center shadow-sm">
            <div class="card-body pt-3 pb-3 d-flex flex-column align-items-center">
                <div class="photo-wrapper mb-3">
                <img
                    v-if="p.profile_picture"
                    :src="p.profile_picture"
                    alt="Performer photo"
                    class="photo img-fluid border rounded shadow-sm d-block mx-auto"
                />
                <div v-else class="photo placeholder bg-light border rounded d-flex align-items-center justify-content-center text-muted">
                    No photo
                </div>
                </div>

                <h5 class="card-title mb-1">{{ p.name }}</h5>

                <div class="mt-1">
                <span class="badge bg-secondary rounded-pill">
                    {{ p.performer_type }}
                </span>
                </div>

                <p v-if="p.about" class="card-text mt-2 about clamp-3">
                {{ p.about }}
                </p>
            </div>

            <div class="card-footer bg-transparent d-flex justify-content-center border-top">
                <button
                class="btn btn-outline-danger btn-sm"
                @click="onDelete(p, idx)"
                :disabled="deletingId === p._id"
                >
                <span v-if="deletingId === p._id">Deleting…</span>
                <span v-else>Delete</span>
                </button>
            </div>
            </div>
      </div>
    </div>
  </div>
</template>

<script>
// Vue 2
import performerService from "../../api/performer.js";

export default {
  name: "PerformerList",
  props: {
    stage_ID: { type: String, required: true },
    stageName: { type: String, required: true },
  },
  data() {
    return {
      performers: [],
      loading: false,
      error: "",
      deletingId: "",
    };
  },
  created() {
    this.fetchPerformers();
  },
  watch: {
    stage_ID() {
      this.fetchPerformers();
    },
  },
  methods: {
    async fetchPerformers() {
        const list = await performerService.getAllPerformers(this.stage_ID);
        // Expecting an array; adapt if your API nests data (e.g., { data: [...] })
        this.performers = Array.isArray(list) ? list : (list?.data || []);
    },
    async onDelete(performer, idx) {
      const ok = window.confirm(`Delete ${performer.name}?`);
      if (!ok) return;

      this.deletingId = performer._id;
      try {
        await performerService.deletePerformerID(performer._id);
        // Remove from local list
        this.performers.splice(idx, 1);
      } catch (e) {
        alert("Failed to delete performer.");
        // optional: console.error(e);
      } finally {
        this.deletingId = "";
      }
    },
  },
};
</script>
<style scoped>
.performer-card .photo {
  width: 260px;              /* tweak to taste */
  height: 260px;             /* keep square; adjust if you prefer 4:3 */
  object-fit: cover;
}

/* Placeholder look when no image */
.performer-card .photo.placeholder {
  font-size: 0.9rem;
}

/* Optional: keep card from growing too wide */
.performer-card {
  max-width: 520px;          /* tweak to fit your grid */
}

/* Optional: clamp about text to 3 lines */
.clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
